<template>
    <!--<div class="selected-filters clearfix">
        <span :class="'text-appearance selected-filter filter-' + tag.id + ' ' + marginClasses" :style="marginInlineStyles" v-for="tag in tagList" @click="removeTag(tag)">
            <i class="fa fa-times" aria-hidden="true"></i> {{ tag.name }}
        </span>

        <span :class="'bg-appearance selected-filter reset-all' + ' '+ marginClasses" :style="marginInlineStyles" v-if="tagList.length >= 2" @click="resetAllTags()">
            {{ $translate("Ceres::Template.itemFilterReset") }}
        </span>
    </div>-->
    <div class="selected-filters clearfix">
        <hr class="d-lg-none">
        <div class="selected-filters__wrapper">
            <span :class="'selected-filter filter-' + tag.id" v-for="tag in tagList"
                v-if="tag.id < 22 || tag.id > 90 || tag.id === 'price'" @click="removeTag(tag)">
                <span>{{ tag.name }}</span> <svg height="9" width="9">
                    <use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
            </span>
        </div>

        <span class="selected-filter reset-all"
            v-if="tagList.length >= 2 || (tagList.length === 1 && tagList[0].id === 'price')" @click="resetAllTags()">
            {{ $translate("Ceres::Template.itemFilterReset") }}
        </span>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
    props: {
        facetData:
        {
            type: Array,
            default() {
                return [];
            }
        },
        marginClasses:
        {
            type: String,
            default: null
        },
        marginInlineStyles:
        {
            type: String,
            default: null
        }
    },

    created() {
        if (!this.$store.state.itemList.facets?.length) {
            this.$store.commit("addFacets", this.facetData);
        }
    },

    computed: mapState({
        tagList: state => state.itemList.selectedFacets
    }),

    methods:
    {
        removeTag(tag) {
            this.selectFacet({ facetValue: tag });
            this.loadItemList();
        },

        resetAllTags() {
            this.resetAllSelectedFacets();
            this.loadItemList();
        },

        ...mapMutations([
            "resetAllSelectedFacets"
        ]),

        ...mapActions([
            "selectFacet",
            "loadItemList"
        ])
    }
}
</script>
